import ChevronDownIcon from "@mixitone/icons/chevron-down.svg";
import ChevronUpIcon from "@mixitone/icons/chevron-up.svg";
import clsx from "clsx";

interface Props<SortField extends string> {
  field: SortField;
  currentField: SortField;
  direction: "asc" | "desc";
  onSort: (field: SortField) => void;
}

export function SortButton<SortField extends string>({
  field,
  currentField,
  direction,
  onSort,
}: Props<SortField>) {
  const isCurrentField = currentField === field;

  return (
    <div className="flex w-full justify-center">
      <button
        onClick={() => onSort(field)}
        className={clsx(
          "flex items-center gap-0.5 py-0 text-xs font-normal text-gray-500 transition-opacity hover:text-gray-700",
          {
            "opacity-100": isCurrentField,
            "opacity-0 group-hover/header:opacity-100": !isCurrentField,
          },
        )}
      >
        Sort
        {isCurrentField &&
          (direction === "asc" ? (
            <ChevronUpIcon className="h-3 w-3 shrink-0" />
          ) : (
            <ChevronDownIcon className="h-3 w-3 shrink-0" />
          ))}
      </button>
    </div>
  );
}
